import React, { useState } from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkIcon from "@mui/icons-material/Link";
import IosShareIcon from "@mui/icons-material/IosShare";
import CheckIcon from "@mui/icons-material/Check";
import styled from "styled-components";
import { Actions, Card, CardTitle, Eyebrow, InkButton, Muted, PrimaryButton, QuietButton } from "./groupBasketStyles";

/*
 * Share the basket's link. The text is the server's (`shareText`: the link on
 * its own line, no emoji) and is sent as given; WhatsApp leads because that is
 * where Kampala shares.
 */
const GroupBasketShare = ({ shareUrl, shareText, justCreated = false }) => {
  const [copied, setCopied] = useState(false);
  if (!shareUrl) return null;

  const message = shareText || shareUrl;
  const canShareNatively = typeof navigator !== "undefined" && typeof navigator.share === "function";

  const shareOnWhatsApp = () => {
    window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, "_blank", "noopener,noreferrer");
  };
  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch (_) {
      setCopied(false);
    }
  };
  const shareNatively = async () => {
    try {
      await navigator.share({ title: "Order together on Lusuku", text: message });
    } catch (_) {
      /* the shopper closed the share sheet */
    }
  };

  return (
    <Card aria-label="Share the basket">
      <Eyebrow>{justCreated ? "Your basket is open" : "Invite friends"}</Eyebrow>
      <CardTitle>Share the link</CardTitle>
      <Muted>Friends open it, add their own items and join this one order.</Muted>
      <LinkLine title={shareUrl}>{shareUrl}</LinkLine>
      <Actions>
        <PrimaryButton type="button" onClick={shareOnWhatsApp}>
          <WhatsAppIcon aria-hidden="true" />
          Share on WhatsApp
        </PrimaryButton>
        <QuietButton type="button" onClick={copyLink} aria-live="polite">
          {copied ? <CheckIcon aria-hidden="true" /> : <LinkIcon aria-hidden="true" />}
          {copied ? "Link copied" : "Copy link"}
        </QuietButton>
        {canShareNatively && (
          <InkButton type="button" onClick={shareNatively}>
            <IosShareIcon aria-hidden="true" />
            More ways to share
          </InkButton>
        )}
      </Actions>
    </Card>
  );
};

const LinkLine = styled.p`
  margin: 12px 0 0;
  padding: 10px 12px;
  border-radius: 10px;
  background: #f3f7ef;
  font-size: 14px;
  font-weight: 700;
  color: #24525f;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default GroupBasketShare;
